import React from 'react';
import ChatBot from '@/components/ChatBot/ChatBot';
import BackgroundPages from '@/global/Background/BackgroundPages';
import useScrollWindow from '@/hooks/useScrollWindow';

export default function ChatBotPage() {
  const { isMobile, isTablet } = useScrollWindow();
  const isDesktop = !isMobile && !isTablet;

  return (
    <React.Fragment>
      <div className="apply-trial-page">
        <BackgroundPages />
        <div className="relative z-10">
          <ChatBot />
        </div>
      </div>
    </React.Fragment>
  );
}
